export interface IComponentCanDeactivate {
  canDeactivate: () => Promise<boolean>;
}

export const canLeavePageGuard = (component: IComponentCanDeactivate) => {
  return component.canDeactivate();
};
